<div class="aqi-indicator-simple">
    <value-circle [value]="value" [color]="measureZones.getColor(value, AQI)"></value-circle>
</div>
